<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-6 mt-2">
        <div class="d-flex">
          <button
            class="w-25 m-2"
            style="
              background: #1481da;
              border: none;
              height: 40px;
              color: white;
            "
          >
            Cửa hàng
          </button>
          <button
            class="w-25 m-2"
            style="background: #eeeeee; border: none; height: 40px"
          >
            Danh mục
          </button>
          <button
            class="w-25 m-2"
            style="background: #eeeeee; border: none; height: 40px"
          >
            Sản phẩm
          </button>
          <button
            class="w-25 m-2"
            style="background: #eeeeee; border: none; height: 40px"
          >
            Khuyến mãi
          </button>
        </div>
      </div>
      <div class="col-12 col-md-12 mt-2">
        <div class="container-fluid">
          <form class="row">
            <div class="col-12 col-md-6 mt-2">
              <div class="d-flex flex-column">
                <label style="text-align: start; color: #cbcbcb">
                  Tên cửa hàng</label
                >
                <input
                  placeholder="Nhập tên cửa hàng"
                  style="
                    height: 40px;
                    border: none;
                    border-bottom: 1px #cbcbcb solid;
                  "
                />
              </div>
              <div class="d-flex flex-column mt-4">
                <label style="text-align: start; color: #cbcbcb">
                  Địa chỉ</label
                >
                <input
                  placeholder="Nhập địa chỉ"
                  style="
                    height: 40px;
                    border: none;
                    border-bottom: 1px #cbcbcb solid;
                  "
                />
              </div>
              <div class="container-fluid p-0 mt-3">
                <div class="row">
                  <div class="col-12 col-md-6 mt-2">
                    <div class="d-flex">
                      <span style="text-align: start; color: #cbcbcb">
                        Lat:
                      </span>
                      <input
                        placeholder="Nhập tên cửa hàng"
                        style="
                          height: 40px;
                          border: none;
                          border-bottom: 1px #cbcbcb solid;
                        "
                      />
                    </div>
                  </div>
                  <div class="col-12 col-md-6 mt-2">
                    <div class="d-flex">
                      <span style="text-align: start; color: #cbcbcb">
                        Long</span
                      >
                      <input
                        placeholder="Nhập tên cửa hàng"
                        style="
                          height: 40px;
                          border: none;

                          border-bottom: 1px #cbcbcb solid;
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mt-2"></div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>